import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';
import ReactCountdown from 'react-countdown';

import { HeroDuration } from '@/v2/services/sanity/types/api/response/homepageHero';

const Divider = () => (
  <Flex mx="8px" alignItems="flex-start" mt="8px">
    :
  </Flex>
);

const Block = styled(Flex)`
  flex-direction: column;
`;

const Number = styled(Flex)`
  background: #870000;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
`;

const Label = styled(Flex)`
  width: 40px;
  height: 30px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;

const renderer = ({
  days,
  hours,
  minutes,
  seconds,
}: {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}) => {
  return (
    <Flex>
      <Block>
        <Number>{days}</Number>
        <Label>Days</Label>
      </Block>
      <Divider />
      <Block>
        <Number>{hours}</Number>
        <Label>Hours</Label>
      </Block>
      <Divider />
      <Block>
        <Number>{minutes}</Number>
        <Label>Mins</Label>
      </Block>
      <Divider />
      <Block>
        <Number>{seconds}</Number>
        <Label>Secs</Label>
      </Block>
    </Flex>
  );
};

interface CountdownProps {
  duration: Pick<HeroDuration, 'end'>;
}

const Countdown = ({ duration }: CountdownProps) => {
  const date = useMemo(
    () => new Date(duration.end.utc).getTime(),
    [duration.end.utc],
  );

  return (
    <Flex
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      <ReactCountdown date={date} renderer={renderer} />
    </Flex>
  );
};

export default Countdown;
